import { Button, Flex, Stack } from '@grubhubprod/gh-cookbook-react';
import React from 'react';
import { FormProvider, useForm } from 'react-hook-form/dist/index.ie11';
import { AllowanceAmountCurrencyInput } from 'src/components/oneCorp/features/MealCredit/common/formFields/CurrencyInput/AllowanceAmountCurrencyInput';

export interface IAllowanceAmountFormProps {
  onFormSubmit: (fields: IAllowanceAmountFormFields) => Promise<void>;
  onCancel: () => void;
  amount: string;
  isCancelButtonDisabled: boolean;
}

export interface IAllowanceAmountFormFields {
  allowanceAmount: string;
}

export function AllowanceAmountForm({
  onFormSubmit,
  onCancel,
  amount,
  isCancelButtonDisabled,
}: IAllowanceAmountFormProps): JSX.Element {
  const useFormProps = useForm<IAllowanceAmountFormFields>({
    mode: 'onChange',
    defaultValues: { allowanceAmount: amount },
  });
  const { handleSubmit, formState } = useFormProps;
  const { isValid, isSubmitting } = formState;

  return (
    <FormProvider {...useFormProps}>
      <form>
        <Flex>
          <Stack x="x-sm">
            <AllowanceAmountCurrencyInput
              id="allowanceAmount"
              name="allowanceAmount"
            />
          </Stack>
          <Stack x="x-sm">
            <Stack y="xxx-sm">&nbsp;</Stack>
            <Button
              variant="primary"
              block
              buttonSize="small"
              disabled={!isValid || isSubmitting}
              isLoading={isSubmitting}
              onClick={handleSubmit(onFormSubmit)}
            >
              Save
            </Button>
          </Stack>
          <Stack>
            <Stack y="xxx-sm">&nbsp;</Stack>
            <Button
              disabled={isSubmitting || isCancelButtonDisabled}
              buttonSize="small"
              variant="tertiary"
              block
              type="button"
              onClick={onCancel}
            >
              Cancel
            </Button>
          </Stack>
        </Flex>
      </form>
    </FormProvider>
  );
}
